import { render, staticRenderFns } from "./Backbar.vue?vue&type=template&id=63adedc2&scoped=true&"
import script from "./Backbar.vue?vue&type=script&lang=js&"
export * from "./Backbar.vue?vue&type=script&lang=js&"
import style0 from "./Backbar.vue?vue&type=style&index=0&id=63adedc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adedc2",
  null
  
)

export default component.exports